import {Component, OnInit} from '@angular/core';
import {LogoComponent} from "../../components/logo/logo.component";
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {ToastrService} from 'ngx-toastr';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';

@Component({
  selector: 'app-password-reset',
  imports: [
    LogoComponent,
    RouterLink,
    TranslocoPipe,
    ReactiveFormsModule
  ],
  templateUrl: './password-reset.html',
  styleUrl: './password-reset.scss'
})
export class PasswordReset implements OnInit {
  public requestForm: FormGroup;
  public resetPasswordForm: FormGroup;
  public loading = false;
  public hasTokenInUrl = false;
  public token: string | null = null;
  public email: string | null = null;

  public constructor(
    private readonly toastr: ToastrService,
    private readonly transloco: TranslocoService,
    private readonly authenticationService: AuthenticationService,
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.requestForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
    this.resetPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      passwordConfirm: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  public ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.token = params.get('token');
      this.email = params.get('email');
      this.resetPasswordForm.get('email')?.setValue(this.email);
      this.hasTokenInUrl = !!this.token;
      if (this.hasTokenInUrl && !this.email) {
        this.toastr.error(
          this.transloco.translate('password-reset.invalid-token.content'),
          this.transloco.translate('password-reset.invalid-token.title')
        );
      }
    });
  }

  public resetPassword() {
    if (this.requestForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService.requestPasswordReset(
      this.requestForm.value.email
    ).subscribe(
      () => {
        this.toastr.success(
          this.transloco.translate('password-reset.request.success.content'),
          this.transloco.translate('password-reset.request.success.title')
        );
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  public resetPasswordWithToken() {
    if (this.resetPasswordForm.invalid || !this.token || !this.email) {
      return;
    }

    const { email, password, passwordConfirm } = this.resetPasswordForm.value;
    this.loading = true;
    this.authenticationService.resetPassword(this.token, email, password, passwordConfirm).subscribe(
      () => {
        this.toastr.success(
          this.transloco.translate('password-reset.reset.success.content'),
          this.transloco.translate('password-reset.reset.success.title')
        );
        this.loading = false;
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 5000);
      }
    )
  }
}
